'use strict'
import serviceBase from './serviceBase'
const userEmails = {
    sendMail:(data)=>serviceBase.post('/useremails',data),
}
export default userEmails